import { render, staticRenderFns } from "./WhyOnHold.vue?vue&type=template&id=6afe8298&scoped=true"
import script from "./WhyOnHold.vue?vue&type=script&lang=js"
export * from "./WhyOnHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe8298",
  null
  
)

export default component.exports